import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { KEYWORDSLIST } from "./keywordList";

@Component({
  selector: "keywords",
  templateUrl: "./keywords.component.html",
  styleUrls: ["./keywords.component.scss"],
  standalone: false,
})
export class KeywordsComponent implements OnInit {
  @Input() data: any;
  keywords = [];
  keywordList = KEYWORDSLIST;

  constructor() {}

  ngOnInit(): void {
    this.initDatas();
  }

  async initDatas() {
    if (this.data && this.data.length > 0) {
      for (let i = 0; i < this.data.length; i++) {
        for (let j = 0; j < this.keywordList.length; j++) {
          if (this.data[i] === this.keywordList[j].code) {
            this.keywords.push(this.keywordList[j]);
            j = this.keywordList.length;
          }
        }
      }
    }
  }
}
